import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {
  ThemeOptions,
  createMuiTheme,
  // useMediaQuery,
} from '@material-ui/core';

import theme, { ThemeModes } from './theme';
import { EmptyObject } from '../../react-app-env';
import { useAutoDarkMode } from '../../hooks/useAutoDarkMode';

interface Props extends React.PropsWithChildren<EmptyObject> {
  modes: ThemeModes;
}

interface CustomThemeContextItems {
  darkMode: boolean;
}

export const CustomThemeContext = React.createContext<CustomThemeContextItems | null>(null);

const CutsomThemeProvider = ({ children, modes }: Props): React.ReactElement => {
  const darkMode = useAutoDarkMode();

  const mainTheme = createMuiTheme(theme(darkMode, modes) as ThemeOptions);

  return (
    <CustomThemeContext.Provider value={{ darkMode }}>
      <MuiThemeProvider theme={mainTheme}>{children}</MuiThemeProvider>
    </CustomThemeContext.Provider>
  );
};

export default CutsomThemeProvider;
